export class EnvironmentUtil {
    public static isDev(): boolean {
        return import.meta.env.MODE === 'development';
    }

    public static isProd(): boolean {
        return import.meta.env.MODE === 'production';
    }

    public static getApiBaseUrl(): string {
        // If environment variable is explicitly set, use it
        if (import.meta.env.VITE_API_BASE_URL) {
            return import.meta.env.VITE_API_BASE_URL;
        }

        // Otherwise, use environment-specific defaults
        if (this.isDev()) {
            return 'https://api.doktar.cc';
        }
        
        if (this.isProd()) {
            return 'https://api.doktar.io';
        }

        // Fallback
        return 'https://api.doktar.cc';
    }

    public static getPestDetectionGetApiUrl(pestDetectionId: string): string {
        const baseUrl = this.getApiBaseUrl();
        return `${baseUrl}/v4.0/weather-soil-pest/get-pest-detection/${pestDetectionId}`;
    }

    public static getPestDetectionUpdateApiUrl(pestDetectionId: string): string {
        const baseUrl = this.getApiBaseUrl();
        return `${baseUrl}/v4.0/weather-soil-pest/update-pest-detection/${pestDetectionId}`;
    }

    public static getPestDetectionApiUrl(pestDetectionId: string): string {
        return this.getPestDetectionUpdateApiUrl(pestDetectionId);
    }

    public static getEnvironmentName(): string {
        if (this.isDev()) return 'development';
        if (this.isProd()) return 'production';
        return 'unknown';
    }
}